export default __webpack_public_path__ + "static/media/cxBTC.eeba3cb8.png";